import { useParams } from 'react-router-dom';

export function useCurrentAutomationId(): string | undefined {
  const { workflowEventSettingId: currentAutomationId } = useParams<{ workflowEventSettingId?: string }>();
  return currentAutomationId;
}
